import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, split } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import App from './App';
import { BatchHttpLink } from "apollo-link-batch-http";
import introspectionQueryResultData from './fragmentTypes.json';
import { createBrowserHistory } from 'history';

const uri = '/graphql';

const httpLink = new HttpLink({ uri });

const history = createBrowserHistory();

const batchHttpLink = new BatchHttpLink({
    uri, headers: { batch: true }, batchInterval: 100
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    const token = localStorage.getItem('token');

    if (token) {
      headers = { ...headers, 'x-token': token };
    }

    return { headers };
  });
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log("graphQLErrors", graphQLErrors);
    graphQLErrors.forEach(({ extensions }) => {
      if (extensions && extensions.code === 'UNAUTHENTICATED') {
        localStorage.removeItem('token');
      }
    });
  }

  if (networkError) {
    if (networkError.statusCode === 401) {
      localStorage.removeItem('token');
      client.resetStore();
      history.push('/login');
    }
  }
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const httpLinkAuth = ApolloLink.from([authLink, errorLink, httpLink]);
const batchHttpLinkAuth = ApolloLink.from([authLink, errorLink, batchHttpLink]);

const client = new ApolloClient({
  link: split(
    operation => operation.getContext().important === true,
    httpLinkAuth,
    batchHttpLinkAuth
  ),
  // link: httpLinkAuth,
  cache: new InMemoryCache({ fragmentMatcher }),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root'),
);
